module.exports = __webpack_public_path__ + "static/media/Luxury.6daa84c3.mp3";